import C5BaseDAO from "./C5BaseDAO";
import LojaModel from "../../model/LojaModel";
import C5DataRetiradaModel from "../../model/C5DataRetiradaModel";

class C5RetiradaDAO extends C5BaseDAO {
  private static instance: C5RetiradaDAO;
  private endpoint = `${super.getBasePath()}/DeliveryWindowOption`;

  private constructor() {
    super();
  }

  public static getInstance(): C5RetiradaDAO {
    if (!C5RetiradaDAO.instance) {
      C5RetiradaDAO.instance = new C5RetiradaDAO();
    }
    return C5RetiradaDAO.instance;
  }

  public async getRetiradaOpcoes(
    loja: LojaModel
  ): Promise<C5DataRetiradaModel[]> {
    return this.get(
      `REQ_C5_HORARIO_RETIRADA_R_${loja.lojaId}`,
      `${this.endpoint}?StoreId=${
        loja.lojaId
      }&DeliveryType=R&nonce=${new Date().getTime()}`
    ).then((r: any) => {
      return r.data.map((day: any) => {
        return C5DataRetiradaModel.toModel(day);
      });
    });
  }

  public async getDeliveryOpcoes(
    loja: LojaModel
  ): Promise<C5DataRetiradaModel[]> {
    return this.get(
      `REQ_C5_HORARIO_RETIRADA_D_${loja.lojaId}`,
      `${this.endpoint}?StoreId=${
        loja.lojaId
      }&DeliveryType=E&nonce=${new Date().getTime()}`
    ).then((r: any) => {
      return r.data.map((day: any) => {
        return C5DataRetiradaModel.toModel(day);
      });
    });
  }
}

export default C5RetiradaDAO;
